import { FiberManualRecord } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import useSelectedLanguage from 'App/hooks/useSelectedLanguage'
import { FC } from 'react'

interface TranslationProps {
  overriddenProperties?: string[]
}
const TranslationIndicator: FC<TranslationProps> = ({
  overriddenProperties,
}) => {
  const { selectedLanguage, isTranslationsEnabled } = useSelectedLanguage()

  const hasOverriddenProperties = overriddenProperties?.length > 0

  if (
    isTranslationsEnabled &&
    selectedLanguage === 'en' &&
    hasOverriddenProperties
  ) {
    return (
      <Stack
        direction="row"
        alignItems="flex-start"
        spacing={1}
        mb={2}
        data-testid="translation-indicator"
      >
        <FiberManualRecord color="info" />
        <Typography variant="subtitle1">
          This page has been manually translated.
        </Typography>
      </Stack>
    )
  }
}

export default TranslationIndicator
